import { useId, type SVGProps } from 'react';

/**
 * Union Jack (GB) flag. Decorative by default (`aria-hidden`); any adjacent label carries the
 * meaning. Uses `preserveAspectRatio="xMidYMid slice"` (the SVG equivalent of CSS `object-cover`)
 * so the flag fills — and is cropped to — whatever box it's given without ever distorting, matching
 * the Figma treatment. Give it a fixed-ratio box (and clip/round via the parent) when rendering.
 * Clip-path ids are generated with `useId` so multiple instances never collide.
 */
export const GbFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => {
    const id = useId();
    const clipAll = `${id}-all`;
    const clipDiag = `${id}-diag`;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 60 30"
            preserveAspectRatio="xMidYMid slice"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}>
            <clipPath id={clipAll}>
                <rect width="60" height="30" />
            </clipPath>
            <clipPath id={clipDiag}>
                <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
            </clipPath>
            <g clipPath={`url(#${clipAll})`}>
                <rect width="60" height="30" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#${clipDiag})`} stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    );
};
